"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const react_1 = __importDefault(require("react"));
require("./spinner.css");
const lang = __importStar(require("./lang.json"));
;
/**
 * Main component.
 * @name spinner
 * @param { SpinnerProps}
 * @returns {< Spinner></Spinner>}
*/
const Spinner = ({ show, text = lang.defaultText }) => {
    return react_1.default.createElement(react_1.default.Fragment, null, (show) && (react_1.default.createElement("div", { id: "spinner", className: "spinner-container bg-spinner" },
        react_1.default.createElement("div", { className: "spinner-container" },
            react_1.default.createElement("div", { id: "spinner1", className: "new", "data-testid": "spinner-element-child" })),
        react_1.default.createElement("div", { className: "msg" }, text))));
};
exports.Spinner = Spinner;
//# sourceMappingURL=spinner.js.map